import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BlockUIModule} from 'ng-block-ui';
import {TemaModule} from './@tema/tema.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './components/login/login.component';
import {MatdialogService} from './services/utils/mat-dialog/mat-dialog.service';
import {HttpConfigInterceptor} from './services/interceptor.service';
import {environment} from 'src/environments/environment';

// NGRX
import {StoreModule, MetaReducer} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {appReducers} from './@store/app.reducers';
import {EffectsArray} from './@store/effects/index';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Angular2CsvModule} from 'angular2-csv';
import {PreLoginComponent} from './components/preLogin/prelogin';
import {localStorageSync} from 'ngrx-store-localstorage';

// --- 🔐 Helpers para encriptar/decodificar con base64 --- //
function encode(value: any): string {
  return btoa(JSON.stringify(value));
}

function decode(value: string): any {
  return JSON.parse(atob(value));
}

//  ID de sesión del sessionStorage - usar un ID fijo para mantener persistencia entre sesiones
const sessionId = 'repse_session'; // ID fijo en lugar de dinámico
// clave única para el localStorage
const localStorageKey = `empresaState_${sessionId}`;

// export function localStorageSyncReducer(reducer: any): any {
//   return localStorageSync({
//     keys: ['empresa'], // Propiedad a persistir
//     rehydrate: true,    // Para cargar los datos al iniciar la app
//     storageKeySerializer: () => localStorageKey,
//     Esta función maneja cómo se guardan y cargan los datos.
// })(reducer);
// }

// --- Reducer para persistencia en localStorage con codificación --- //
export function localStorageSyncReducer(reducer: any): any {
  return localStorageSync({
    keys: [
      {
        empresa: {
          serialize: (value: any) => encode(value),   // 👉 Guardar codificado
          deserialize: (value: string) => {
            try {
              return decode(value); // 👉 Recuperar decodificado
            } catch (e) {
              console.warn('Estado corrupto, se limpia localStorage.');
              localStorage.removeItem(localStorageKey);
              return null;
            }
          },
        },
      },
    ],
    rehydrate: true, // 🔑 Recarga automáticamente el estado al iniciar
    storageKeySerializer: () => localStorageKey,
  })(reducer);
}

const metaReducers: MetaReducer<any, any>[] = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PreLoginComponent,

  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    BlockUIModule.forRoot(),
    TemaModule,
    Angular2CsvModule,
    // TemaModule.forRoot(),
    StoreModule.forRoot(appReducers, { metaReducers }),
    EffectsModule.forRoot(EffectsArray),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
  ],
  providers: [
    MatdialogService,
    {provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
